export const ELECTION_LOADING = 'loading';
export const ELECTION_LOGIN = 'login';
export const ELECTION_LOGIN_RECEIPT = 'loginReceipt';
export const ELECTION_INVALID_PASSWORD = 'invalidPassword';
export const ELECTION_RECEIPT = 'receipt';
export const ELECTION_RESULT = 'result';
export const ELECTION_RESULT_COUNTING = 'resultCounting';
export const ELECTION_VOTING = 'voting';
export const ELECTION_VOTING_DELIBERATION = 'voting_deliberation';